import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'app',
    children: [
      {
        path: 'action',
        loadChildren: () => import('./pages/action-page/action-page.module').then( m => m.ActionPageModule)
      },
      {
        path: 'corp',
        loadChildren: () => import('./pages/corp-page/corp-page.module').then( m => m.CorpPageModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
